import {Component, Input, OnChanges} from '@angular/core';
import {LoggerService} from "../../../common/logger.service";
import {AlertService} from "../../alert.service";
import {UserService} from "../../../common/user.service";
import {BaseComponent} from "../../../base.component";
import {Constants} from "../../../constants";
import {IAlert, IAlertBody} from "../../alert-model";
import {TranslateService} from "../../../translation/translate.service";
import {from, Observable, of} from "rxjs";

@Component({
    selector: 'general-alert',
    templateUrl: './general-alert.component.html',
    styleUrls: ['../../alert.scss'],
    standalone: false
})
export class GeneralAlertComponent extends BaseComponent implements OnChanges {

    @Input() alert: IAlert;
    alertTitle: string;
    alertMessage: string;

    constructor(userService: UserService,
                loggerService: LoggerService,
                private alertService: AlertService,
                private translateService: TranslateService) {
        super(userService, loggerService);
    }

    ngOnChanges(): void {
        if (this.alert) {
            if (this.alert.title) {
                this.getAlertText(this.alert.title).subscribe((val: string) => this.alertTitle = val);
            }
            if (this.alert.message) {
                this.getAlertText(this.alert.message).subscribe((val: string) => this.alertMessage = val);
            }
        }
    }

    getAlertText(alertBody: IAlertBody): Observable<string> {
        if (alertBody.translateRequest) {
            return from(this.translateService.translateRequest(alertBody.translateRequest));
        } else if (alertBody.translate) {
            return from(this.translateService.translate(alertBody.body));
        } else {
            return of(alertBody.body);
        }
    }

    getClass() {
        return Constants.ALERT_STYLE_PREFIX + (this.alert.type || Constants.ALERT_SUCCESS);
    }

    getFontAwesomeIcon() {
        switch (this.alert.type) {
            case Constants.ALERT_SUCCESS:
                return 'fa-check';
            case Constants.ALERT_DANGER:
                return 'fa-circle-exclamation';
            case Constants.ALERT_WARNING:
                return 'fa-triangle-exclamation';
            default:
                return '';
        }
    }

    closeAlert() {
        this.alertService.closeAlert(this.alert);
    }

}
